import { ITestimonialData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IContentItemTestimonial } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class Testimonial {
  parrentType: string;
  description: string;
  isMemberLike: boolean;
  testimonialTypeId: number;
  dateCreated: number | string | undefined;

  constructor() {
    this.parrentType = '';
    this.description = '';
    this.isMemberLike = false;
    this.testimonialTypeId = 0;
    this.dateCreated = '';
  }

  static mappingObject(_obj: ITestimonialData): IContentItemTestimonial {
    let obj = Object.assign(new Testimonial(), _obj);
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.testimonialTypeId = _obj.TestimonialTypeId || -1;
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj = utils.cleanObjectKeys(Object.keys(new Testimonial()), obj);

    return obj;
  }

  static mappingObjects(_data: ITestimonialData[]): IContentItemTestimonial[] {
    return _data.map(item => Testimonial.mappingObject(item));
  }
}
